__turbopack_context__.v({
  "button": "charter-block1440px-module-scss-module__BgAnlW__button",
  "buttonprimarywithicon": "charter-block1440px-module-scss-module__BgAnlW__buttonprimarywithicon",
  "buttons": "charter-block1440px-module-scss-module__BgAnlW__buttons",
  "buttonsecondary": "charter-block1440px-module-scss-module__BgAnlW__buttonsecondary",
  "callHeraFlightToday": "charter-block1440px-module-scss-module__BgAnlW__callHeraFlightToday",
  "callTo": "charter-block1440px-module-scss-module__BgAnlW__callTo",
  "callTo1833FlyHeraContainer": "charter-block1440px-module-scss-module__BgAnlW__callTo1833FlyHeraContainer",
  "charterblock1440px": "charter-block1440px-module-scss-module__BgAnlW__charterblock1440px",
  "descriptor": "charter-block1440px-module-scss-module__BgAnlW__descriptor",
  "featuresblock": "charter-block1440px-module-scss-module__BgAnlW__featuresblock",
  "flyHera": "charter-block1440px-module-scss-module__BgAnlW__flyHera",
  "gardencallIn26Icon": "charter-block1440px-module-scss-module__BgAnlW__gardencallIn26Icon",
  "imageIcon": "charter-block1440px-module-scss-module__BgAnlW__imageIcon",
  "leftcol": "charter-block1440px-module-scss-module__BgAnlW__leftcol",
  "lookingForAnother": "charter-block1440px-module-scss-module__BgAnlW__lookingForAnother",
  "title": "charter-block1440px-module-scss-module__BgAnlW__title",
});
